var paragraph_default = {
  "fontElementMap": "ZJ7nx",
  "elementSpacing": "_4mQX9",
  "text": "_5-JU0 _4mQX9",
  "child": "_76CJZ"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
